module.exports = __webpack_public_path__ + "media/premium.4b53fa4b.svg";